module.exports = __webpack_public_path__ + "img/CriticalHeightVariations-min.ecc85b7d.png";